import {
  onBeforeUnmount,
  onMounted,
  ref,
} from 'vue';

export const useZoom = () => {
  const zoom = ref(1);

  const onWindowHeightChange = () => {
    const baseHeight = 900;
    const zoomAtBase = 1;

    // set custom zoom value only on desktop
    if (window.innerWidth > 600) {
      zoom.value = (window.innerHeight / baseHeight) * zoomAtBase;
    } else {
      zoom.value = 1;
    }

    document.documentElement.style.setProperty(
      '--zoom-for-desktop',
      `${zoom.value}`,
    );
  };

  onMounted(() => {
    window.addEventListener('resize', onWindowHeightChange);

    onWindowHeightChange();
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', onWindowHeightChange);
  });

  return {
    zoom,
  };
};
